import styled from '@emotion/styled'

import { Color, theme } from '../../constants'

const StyledInput = styled.input`
  border: none;
  width: max-content;
  text-align: center;
  background: transparent;
  color: inherit;

  ::-webkit-calendar-picker-indicator {
    display: none;
  }
`

export const FirstRowInput = styled(StyledInput)({
  fontSize: theme.font.size[3],
  fontWeight: theme.font.weight.bold,
})

const secondRowStyles = {
  color: Color.DARK_GREY,
  fontSize: theme.font.size[6],
}

export const SecondRowInput = styled(StyledInput)(secondRowStyles)

export const SecondRowText = styled.span(secondRowStyles)
